import { render, staticRenderFns } from "./testemapa3.vue?vue&type=template&id=6f5597a9"
import script from "./testemapa3.vue?vue&type=script&lang=js"
export * from "./testemapa3.vue?vue&type=script&lang=js"
import style0 from "./testemapa3.vue?vue&type=style&index=0&id=6f5597a9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports